import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { POSITIVE_LIST_MEASURE_QUERY_KEY } from "../helpers/measureDetail";

const usePositiveListMeasure = ({ measureId, t } = {}) => {
    return useQuery({
        queryKey: [POSITIVE_LIST_MEASURE_QUERY_KEY, String(measureId)],
        queryFn: async () => {
            const service = PositiveListService.getInstance();

            return await service.getMeasure(measureId);
        },
        enabled: Boolean(measureId),
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t
                    ? t("An error occurred while fetching the measure.")
                    : "An error occurred while fetching the measure.",
                {
                    type: "error",
                }
            );
        },
    });
};

export default usePositiveListMeasure;
